const RESOURCES = {
    GOLD: 'gold',
};

export { RESOURCES };
//# sourceMappingURL=constants.js.map
